import { fmtInt } from "./data";

/** The signature grain-tray fill: reports passed out of reports filed. */
export function Tray({ passed, total }: { passed: number; total: number }) {
  if (!total) {
    return (
      <span className="tray-cap" style={{ margin: 0 }}>
        No reports yet
      </span>
    );
  }
  const pct = Math.round((passed / total) * 100);
  const cls = pct >= 95 ? "green" : pct < 90 ? "low" : "";
  return (
    <>
      <div className="tray">
        <div className={"tray-fill " + cls} style={{ width: `${pct}%` }} />
      </div>
      <span className="tray-cap">
        {fmtInt(passed)} passed / {fmtInt(total)} filed · {pct}%
      </span>
    </>
  );
}
